module.exports = __webpack_public_path__ + "img/clock.2920cf85.svg";